export const getCurrenciesFromCurrencyPair = (currencyPair) => {
    if (!/^([A-Z]|\d){3}\/([A-Z]|\d){3}$/g.test(currencyPair)) {
        throw new TypeError('Invalid CurrencyPair Type');
    }
    const [currencyBase, currencyQuote] = currencyPair.split('/');
    return { currencyBase, currencyQuote };
};
export const getCurrenciesFromCcyPair = (currencyPair) => {
    if (!/^(([A-Z]|\d){3}){2}$/g.test(currencyPair)) {
        throw new TypeError('Invalid Ccypair Type');
    }
    const [currencyBase, currencyQuote] = currencyPair.match(/.{3}/g);
    return { currencyBase, currencyQuote };
};
export const CurrencyPairToCcypair = (currencyPair) => currencyPair.replace('/', '');
export const CcypairToCurrencyPair = (currencypair) => currencypair === null || currencypair === void 0 ? void 0 : currencypair.match(/.{1,3}/g).join('/');
export const getSymbolByCurrencyPair = (symbols) => (currencyPair) => {
    const pair = CurrencyPairToCcypair(currencyPair);
    return symbols.find(symbol => symbol.symbol === pair);
};
export const getSymbolByCcyPair = (symbols) => (currencyPair) => {
    return symbols.find(symbol => symbol.symbol === currencyPair);
};
export function tradedIsBase(traded, base) {
    return traded === base;
}
